module.exports = __webpack_public_path__ + "img/message5.15a7f5fb.png";